import { api } from './client'

/**
 * F-086 (TASK-0340, REQ-297-001): client del registro degli eventi di business (`/api/business-events`,
 * solo Admin). Gli attributi di un evento sono identificativi e vocabolario: mai importi, mai dati personali.
 */
export interface BusinessEventRow {
  id: number
  eventType: string
  eventKey: string
  entityType: string
  entityId: number
  attributes: Record<string, string>
  occurredAt: string
  recordedAt: string
  /** false = riga di baseline: il rilevatore l'ha registrata al primo giro senza annunciarla. */
  published: boolean
}

export interface BusinessEventPage {
  page: number
  pageSize: number
  total: number
  items: BusinessEventRow[]
}

export interface BusinessEventTypeInfo {
  code: string
  label: string
  entityType: string
  automationEligible: boolean
}

export interface BusinessEventFilter {
  type?: string | undefined
  entityType?: string | undefined
  /** Giorno (AAAA-MM-GG), incluso. */
  from?: string | undefined
  /** Giorno (AAAA-MM-GG), incluso. */
  to?: string | undefined
  published?: boolean | undefined
  page?: number | undefined
  pageSize?: number | undefined
}

export const businessEventsApi = {
  types: () => api<BusinessEventTypeInfo[]>('/api/business-events/types'),

  list: (f: BusinessEventFilter = {}) => {
    const q = new URLSearchParams()
    if (f.type) q.set('type', f.type)
    if (f.entityType) q.set('entityType', f.entityType)
    if (f.from) q.set('from', `${f.from}T00:00:00Z`)
    if (f.to) {
      // "fino al giorno incluso": il server confronta con un estremo escluso.
      const end = new Date(`${f.to}T00:00:00Z`)
      end.setUTCDate(end.getUTCDate() + 1)
      q.set('to', end.toISOString())
    }
    if (f.published !== undefined) q.set('published', String(f.published))
    q.set('page', String(f.page ?? 1))
    q.set('pageSize', String(f.pageSize ?? 50))
    return api<BusinessEventPage>(`/api/business-events?${q.toString()}`)
  },
}
